import {getStationCode} from "../../network/NetworkUtil";
import {getAPIGatewayDataFromParent, getDocumentURL} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/Util";

const metricProcessName = "SCC_INDUCT_ASSOCIATE";
export function fetchAssociateMetrics(dispatcher) {
    const request = {
        nodeId: getStationCode()
    }
    getAssociateMetrics(dispatcher, request)
}

function fetchAssociateMetricsAPIGatewayRequest(request) {
    return {
        resourcePath: "/ivs/getAssociateMetric",
        httpMethod: "post",
        processName: "induct",
        requestBody: request
    }
}

async function getAssociateMetrics(dispatcher, request) {
    let baseURL
    getDocumentURL().then(value => baseURL = value);
    const args = fetchAssociateMetricsAPIGatewayRequest(request);
    const startTime = Date.now();
    getAPIGatewayDataFromParent(args).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getAssociateMetrics", true);
            const output = result.data.associateMetricList
            const associateMetric = output.filter(associate => associate.packageHandled > 0).map(associate => {
                associate['alias'] = associate['alias'].toLowerCase();
                return associate;
            })
            dispatcher({type: "RECEIVE_DATA", data: {
                associatePerformance: associateMetric.map(metric => {
                    metric.active = (metric.active) ? 'Yes' : 'No'
                    return metric
                }),
                baseURL: baseURL
            }});
        } else {
            logOperationalMetric(startTime, metricProcessName, "getAssociateMetrics", false);
        }
    });
}


// WEBPACK FOOTER //
// ./src/components/associate/network/AssociateNetworkAPI.js